"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
var _useReactRouter = _interopRequireDefault(require("use-react-router"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const NavMenuItem = ({
  className,
  path,
  exact,
  strict,
  onClick: handleOnClick,
  ...props
}) => {
  const {
    history,
    location
  } = (0, _useReactRouter.default)();
  const onClick = event => {
    history.push(path);
    if (handleOnClick) {
      return handleOnClick(event);
    }
    return true;
  };
  const active = (0, _reactRouter.matchPath)(location.pathname, {
    path,
    exact,
    strict
  });
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({
    className: [className, active ? 'active' : false].filter(Boolean).join(' '),
    active: active,
    onClick: onClick
  }, props));
};
__signature__(NavMenuItem, "useReactRouter{{ history, location }}", () => [_useReactRouter.default]);
NavMenuItem.propTypes = {
  className: _propTypes.default.string,
  path: _propTypes.default.string.isRequired,
  exact: _propTypes.default.bool,
  strict: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
NavMenuItem.defaultProps = {
  className: null,
  exact: false,
  strict: false,
  onClick: null
};
const _default = NavMenuItem;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(NavMenuItem, "NavMenuItem", "/Users/jake.clayton/frontend/ls-common-client/src/components/NavMenuItem.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/NavMenuItem.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();